/**
 * "Continuar de onde parou" (Início): as últimas telas abertas neste navegador, com o caminho "Módulo › Tela".
 * Conveniência por pessoa e por navegador (localStorage); sem armazenamento, a lista só fica vazia.
 */
const KEY = 'hive.recent';
const MAX = 8;

export interface RecentScreen {
  path: string;
  label: string;
  at: number;
}

export function readRecent(): RecentScreen[] {
  try {
    const v = JSON.parse(window.localStorage.getItem(KEY) ?? '[]') as unknown;
    return Array.isArray(v) ? v.filter((x): x is RecentScreen => !!x && typeof x.path === 'string' && typeof x.label === 'string' && typeof x.at === 'number') : [];
  } catch {
    return [];
  }
}

/** Guarda a tela aberta no topo da lista (a mesma rota não se repete; o Início não entra). */
export function pushRecent(path: string, label: string, at = Date.now()) {
  if (!label || path === '/' || path.startsWith('/signin')) return;
  const list = [{ path, label, at }, ...readRecent().filter((x) => x.path !== path)].slice(0, MAX);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* só não lembra */
  }
}
